import { render } from "./reversion-slope-chart.vue?vue&type=template&id=12a71219"
import script from "./reversion-slope-chart.vue?vue&type=script&lang=js"
export * from "./reversion-slope-chart.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__